'use strict';

var SeasonalityOverridesSaveService = function SeasonalityOverridesSaveService(Restangular, UserSecureService) {
  function saveChanges(key, overrides, isPooledSeasonalitySpecialEventsSave) {
    var user = UserSecureService.getUserId();
    var service = isPooledSeasonalitySpecialEventsSave ? Restangular.one('pooled/seasonality/analysis/' + key + '/override?updatedBy=' + user) : Restangular.one('partitioned/seasonality/analysis/' + key + '/override?updatedBy=' + user);
    return service.patch({
      value: overrides
    });
  }
  return {
    saveChanges: saveChanges
  };
};
SeasonalityOverridesSaveService.$inject = ['Restangular', 'UserSecureService'];
module.exports = SeasonalityOverridesSaveService;